import { FormEvent, useCallback } from 'react';
import { excludeCyrillicRegExp } from '../../../utils/regexps';
import { useTranslation } from '../../../utils/useTranslation';
import { composeValidators } from '../../../utils/validators/compose';
import { makeRegExpValidator } from '../../../utils/validators/makeRegExpValidator';
import { WithHint } from '../../feedback/Tooltip';
import { Input as InputBase } from '../../input/Input';
import { makeTextControlValidate } from '../../input/makeTextControlValidate';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { ContentPromotionUtmProps } from './types';
import { utmParamsValidator } from './utils';

const Input = makeTextControlValidate(InputBase);

const utmValidator = composeValidators(
    makeRegExpValidator(excludeCyrillicRegExp, 'Не используйте кириллические символы'),
    utmParamsValidator('Непраивльный формат параметров'),
);

export const ContentPromotionUtm: React.FC<ContentPromotionUtmProps> = ({
    value,
    onChange,
    ...other
}) => {
    const t = useTranslation();

    const onInput = useCallback(
        (event: FormEvent<HTMLInputElement>) => {
            onChange(event.currentTarget.value);
        },
        [onChange],
    );

    return (
        <Wrapper {...other}>
            <Flex direction="row" alignItems="center">
                <Typography variant="title3" weight="bold">
                    {t('Параметры URL')}
                </Typography>
                <WithHint
                    ml={1}
                    iconColor="var(--color-secondary)"
                    message={t(
                        'С помощью параметров и UTM-меток можно отслеживать различные показатели (например, источники трафика) и оценивать эффективность рекламных кампаний. Указанные параметры URL добавятся ко всем ссылкам всех объявлений кампании.\n\nПараметры могут быть статическими и динамическими.\n\nЗначение статических вы задаёте вручную. В динамических система автоматически подставит необходимые данные.',
                    )}
                />
            </Flex>
            <Typography variant="body" py={2}>
                {t(
                    'Введите параметры или UTM-метки. Они добавятся ко всем ссылкам, указанным в настройках объявлений внутри кампании.',
                )}
            </Typography>
            <Input
                name="utm"
                variant="outline"
                placeholder={t('Например, utm_source=rythm&utm_medium=cpc')}
                onInput={onInput}
                value={value}
                validator={utmValidator}
                textOverflow="ellipsis"
            />
        </Wrapper>
    );
};
